import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { BenefitSliderListItem } from '../shared/benefitSliderListItem';
import { CardWidget } from '../../../lib/components/compound/surfaces/cardWidget';
import { BenefitIcon } from '../../../lib/components/compound/dataDisplay';
import { BenefitWishesActiveDashboardWidgetProps } from '../shared';
import { ICON_PROPS } from '../shared';
import { ScrollableList } from '../shared/scrollableList';
import { Loading } from '../../../lib/components';

type Props = BenefitWishesActiveDashboardWidgetProps;

export const BenefitWishesDashboardWidget: FC<Props> = ({ stats, employeeCount, isLoading }) => {
  const { t } = useTranslation();

  return (
    <CardWidget
      title={t('common:BENEFIT_WISHES_TITLE')}
      subTitle={t('common:BENEFIT_WISHES_SUBTITLE', { count: employeeCount })}
    >
      {isLoading ? (
        <Loading />
      ) : (
        <ScrollableList>
          {stats &&
            stats.map((benefit) => (
              <BenefitSliderListItem
                key={benefit.key}
                icon={<BenefitIcon benefitKey={benefit.key} {...ICON_PROPS} />}
                title={t(`benefits:${benefit.key}`)}
                percent={Math.round(benefit.desired_percent)}
              />
            ))}
        </ScrollableList>
      )}
    </CardWidget>
  );
};
